import type { IconNode } from '../types';

/**
 * @name lambda
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEuMzggMTAgNSAyMCIgLz4KICA8cGF0aCBkPSJNMTkgMThhMiAyIDAgMDEtMiAyYy00Ljg3LS4wMDMtNS4wNTItMTYtMTAtMTZhMiAyIDAgMDAtMiAyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/lambda
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Lambda: IconNode = [
  ['path', { d: 'M11.38 10 5 20' }],
  ['path', { d: 'M19 18a2 2 0 01-2 2c-4.87-.003-5.052-16-10-16a2 2 0 00-2 2' }],
];

export default Lambda;
